/*
	Приводит статус к единому виду для UI и сравнения: верхний регистр,
	дефисы и подчёркивания заменяются на пробел, лишние пробелы схлопываются.
*/
export function normalizeStatusLabel(
	raw: string | number | null | undefined,
): string {
	if (raw == null) return "";
	return String(raw)
		.trim()
		.replace(/[_-]+/g, " ")
		.replace(/\s+/g, " ")
		.toUpperCase();
}

// Ключ для фильтров / select: нижний регистр после нормализации
export function normalizeStatusKey(
	raw: string | number | null | undefined,
): string {
	return normalizeStatusLabel(raw).toLowerCase();
}

// Сравнение нормализованных статусов
export function statusMatchesFilter(
	itemStatus: string | number | null | undefined,
	selectedFilterKey: string,
): boolean {
	if (selectedFilterKey === "all") return true;
	return (
		normalizeStatusKey(itemStatus) === normalizeStatusKey(selectedFilterKey)
	);
}
